import { SimpleCallback } from 'platform-components';
import { ShowcaseCardSkeleton } from 'platform-components/src/components/showcase-card/_skeleton-view/showcase-card_skeleton-view';
import React from 'react';

import { ArrowButton } from '../../calendar-plan-showcase/__arrow-button/calendar-plan-showcase__arrow-button';
import { CalendarPlanShowcaseCarouselHeaderSkeleton } from '../../calendar-plan-showcase/__carousel-header/_skeleton-view/calendar-plan-showcase__carousel-header_skeleton-view';
import { CalendarPlanShowcaseHeaderSkeleton } from '../../library.calendar-plan-showcase/__header/_skeleton-view/calendar-plan-showcase__header_skeleton-view';
import { CalendarPlanThemeAdditionalContentSkeleton } from '../../library.calendar-plan-theme/__additional-content-skeleton/calendar-plan-theme__additional-content-skeleton';

import './calendar-plan_skeleton-view.scss';

interface Props {
    withHeader?: boolean;
    onNextItemClick?: SimpleCallback;
    onPrevItemClick?: SimpleCallback;
    hasPrevItem?: boolean;
    hasNextItem?: boolean;
}

export const CalendarPlanSkeleton = (props: Props) => {
    const { withHeader = true, onNextItemClick, onPrevItemClick, hasPrevItem, hasNextItem } = props;
    return (
        <>
            {withHeader && <CalendarPlanShowcaseHeaderSkeleton />}
            <CalendarPlanShowcaseCarouselHeaderSkeleton />
            <div className="skeleton__showcase-wrapper">
                <ShowcaseCardSkeleton />

                {hasNextItem && <div className="skeleton__showcase-next-item" />}

                {hasNextItem && <ArrowButton direction={ArrowButton.DIRECTION.RIGHT} onClick={onNextItemClick} />}
                {hasPrevItem && <ArrowButton direction={ArrowButton.DIRECTION.LEFT} onClick={onPrevItemClick} />}
            </div>

            <CalendarPlanThemeAdditionalContentSkeleton />
        </>
    );
};
